package ru.playa.sce.dto

/**
 * @author Ермаков Игорь Александрович (email: igor.yermakov94@yandex.ru).
 */
class AssetRename(val id: Int, val name: String) {
}